import React, { useRef } from "react";

export const RequiredDatesNote = ({ missing }) => {
  const idx = useRef(0);
  if (!missing || missing.length === 0) return null;

  const go = () => {
    if (idx.current >= missing.length) idx.current = 0;
    const tid = missing[idx.current];
    idx.current += 1;
    const el = document.querySelector(`[data-testid="${tid}"]`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      setTimeout(() => {
        try {
          el.focus({ preventScroll: true });
        } catch (e) {
          /* ignore */
        }
      }, 350);
    }
  };

  return (
    <button
      type="button"
      onClick={go}
      data-testid="date-required-note"
      className="text-sm text-brand-danger underline underline-offset-2 hover:text-brand-black text-left cursor-pointer"
    >
      Please complete the required date field(s) marked with * above before submitting.
    </button>
  );
};
